import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { arrayOf, bool, shape } from 'prop-types';
import { formatNumberWithoutDecimals } from 'utils/helpers/format';
import * as R from 'ramda';

const CustomMinTooltip = ({ active, payload, tooltipData }) => {
  if (active && payload.length) {
    // eslint-disable-next-line prefer-destructuring
    const name = payload[0].name;

    const check = R.cond([
      [R.equals('Contract Min'), R.always(false)],
      [R.equals('Min Required'), R.always(false)],
      [R.equals('Min Projection'), R.always(false)],
      [R.equals('Min Volume'), R.always(true)],
    ]);

    return (
      <Box
        sx={{
          backgroundColor: 'surface.white',
          borderRadius: 0.5,
          boxShadow: 6,
          p: 2,
        }}
      >
        <Stack spacing={1}>
          <Typography sx={{ fontWeight: 700 }} variant="body1">
            {name}
          </Typography>
          <Typography sx={{ fontWeight: 700 }} variant="body1">
            Total Volume: {formatNumberWithoutDecimals(payload[0].value)} bbl
          </Typography>
          {check(name) && (
            <Stack spacing={0.5}>
              <Typography color="text.disabled" variant="caption">
                Controlled Volume: {formatNumberWithoutDecimals(tooltipData.controlled)} bbl
              </Typography>
              <Typography color="text.disabled" variant="caption">
                Uncontrolled Volume: {formatNumberWithoutDecimals(tooltipData.uncontrolled)} bbl
              </Typography>
            </Stack>
          )}
        </Stack>
      </Box>
    );
  }

  return null;
};

CustomMinTooltip.propTypes = {
  active: bool,
  payload: arrayOf(shape({})),
  tooltipData: shape({}),
};

CustomMinTooltip.defaultProps = {
  active: null,
  payload: [],
  tooltipData: null,
};

export default CustomMinTooltip;
